export default ({ $axios, app }) => {
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    $axios.setHeader('Content-Language', newLocale)
  }
}
